/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import store from '@/store';
import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserVipData } from '@/api/types/user';

export interface StoreUserVipState {
  vip: UserVipData;
}

export default {
  namespaced: true,
  state: {
    vip: '',
  },
  getters: {},
  actions: {
    [USER.GET_VIP]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getVip().then((res) => {
          commit(USER.GET_VIP, res.data);
          const oncomplete = (): void => resolve();
          store.dispatch(`user/profile/${USER.GET_PROFILE_OPTIONS}`, {
            action: 'refresh',
          }).then(oncomplete).catch(oncomplete);
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_VIP](state, data) {
      state.vip = data;
    },
  },
};
